import type { SelectOption } from "@clintonelec/react-storybook";
import { times } from "lodash";

export const timeOptions: SelectOption[] = times(10, index => {
	return {
		label: `${ index + 1 } sec`,
		value: index + 1
	};
});

export const bannerModeOptions: SelectOption[] = [
	{
		label: "Single",
		value: "Single"
	},
	{
		label: "Dual (Top & Bottom)",
		value: "Dual"
	},
	{
		label: "Sequence",
		value: "Sequence"
	}
];

export const displayModeOptions: SelectOption[] = [
	{
		label: "Event",
		value: "Event"
	},
	{
		label: "Always",
		value: "Always"
	}
];

export const logoDisplayModeOptions: SelectOption[] = [
	{
		label: "Show Logo on Alarm",
		value: "Show Logo on Alarm"
	},
	{
		label: "Show Camera on Alarm",
		value: "Show Camera on Alarm"
	}
];

export const borderColorOptions: SelectOption[] = [
	{
		label: "Red",
		value: "Red"
	},
	{
		label: "Orange",
		value: "Orange"
	},
	{
		label: "Yellow",
		value: "Yellow"
	},
	{
		label: "Green",
		value: "Green"
	},
	{
		label: "Cyan",
		value: "Cyan"
	},
	{
		label: "Blue",
		value: "Blue"
	},
	{
		label: "Magenta",
		value: "Magenta"
	},
	{
		label: "Black",
		value: "Black"
	},
	{
		label: "White",
		value: "White"
	}
];

export const locationOptions: SelectOption[] = [
	{
		label: "Top",
		value: "Top"
	},
	{
		label: "Bottom",
		value: "Bottom"
	}
];
